import { collectLayoutPanelIds } from '@/common/utils/collectLayoutPanelIds'

function panelHiddenByStates(panelId: number, states: unknown[]): boolean {
  for (const raw of states) {
    if (!raw || typeof raw !== 'object') continue
    const state = raw as Record<string, unknown>
    if (String(state.element_level ?? '').toUpperCase() !== 'PANEL') continue
    if (state.is_visible === undefined) continue
    const id = Number(state.element_id)
    if (Number.isFinite(id) && id === panelId) {
      return state.is_visible === false
    }
  }
  return false
}

/** Все панели main/header/footer скрыты явным is_visible:false в jsResult.states. */
export function areAllLayoutPanelsHiddenByStates(formLike: unknown, states: unknown): boolean {
  const panelIds = collectLayoutPanelIds(formLike)
  if (panelIds.length === 0) {
    return false
  }
  const list = Array.isArray(states) ? states : []
  return panelIds.every((id) => panelHiddenByStates(id, list))
}
